module.exports = __webpack_public_path__ + "static/media/picture-(237).2ab91125.JPG";